var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 60,
    viewBox: "0 0 20 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_771_5104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74993 40.25C8.74993 39.5596 9.30957 39 9.99993 39C10.6903 39 11.2499 39.5596 11.2499 40.25L11.2499 55.0354L14.4192 51.8661C14.9074 51.378 15.6988 51.378 16.187 51.8661C16.6751 52.3543 16.6751 53.1457 16.1869 53.6339L9.99978 59.821L3.8126 53.6339C3.32444 53.1458 3.32443 52.3543 3.81259 51.8661C4.30074 51.378 5.09222 51.378 5.58037 51.8661L8.74992 55.0357L8.74993 40.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25C9.30964 6.25 8.75 6.80964 8.75 7.5L8.75 12.5C8.75 13.1904 9.30964 13.75 10 13.75C10.6904 13.75 11.25 13.1904 11.25 12.5L11.25 7.5C11.25 6.80964 10.6904 6.25 10 6.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.37114e-07 10C-1.95702e-07 4.47715 4.47715 1.95702e-07 10 4.37114e-07C15.5228 6.78523e-07 20 4.47715 20 10L20 20C20 25.5228 15.5228 30 10 30C4.47715 30 -1.11564e-06 25.5228 -8.74227e-07 20L-4.37114e-07 10ZM17.5 10L17.5 20C17.5 24.1421 14.1421 27.5 10 27.5C5.85786 27.5 2.5 24.1421 2.5 20L2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_771_5104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.f4e3af223a88b17b92001ec88950a8ed.svg";
export { ForwardRef as ReactComponent };